import { Permission } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import * as SalesStore from '../SalesStore';

declare global {
	interface CommandType {
		nextSeatNumber: () => Promise<Result>
	}
}

Command.register('nextSeatNumber', Preconditions.ensure(Permission.Ticket_NextSeatNumber), async (): Promise<Result> => {
	SalesStore.nextSeatNumber();
	return Result.ok();
});